import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card transform hover:-translate-y-1 transition-all duration-300 ease-out group" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "ml-5 flex-1 min-h-[64px] flex flex-col justify-center" }
const _hoisted_5 = { class: "text-sm font-medium text-secondary-text/70 dark:text-secondary-dark-text/70 uppercase tracking-wide" }
const _hoisted_6 = { class: "mt-2 h-8 flex items-center" }
const _hoisted_7 = {
  key: 1,
  class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text"
}

import { computed } from 'vue'

import PulseLoader from '@/components/common/PulseLoader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStatsCard',
  props: {
    title: {},
    value: {},
    icon: {},
    color: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const iconBgClass = computed(() => {
  const colors = {
    primary: 'from-primary to-primary-hover dark:from-primary-dark dark:to-primary-dark-hover',
    success: 'from-success to-success-hover dark:from-success-dark dark:to-success-dark-hover',
    danger: 'from-danger to-danger-hover dark:from-danger-dark dark:to-danger-dark-hover',
    warning: 'from-warning to-warning-hover dark:from-warning-dark dark:to-warning-dark-hover',
    info: 'from-info to-info-hover dark:from-info-dark dark:to-info-dark-hover'
  }
  return colors[props.color || 'primary']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-shrink-0 rounded-xl p-3.5 shadow-elegant-lg bg-gradient-to-br", iconBgClass.value])
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { class: "h-6 w-6 text-white" }))
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.title), 1),
          _createElementVNode("div", _hoisted_6, [
            (__props.loading)
              ? (_openBlock(), _createBlock(PulseLoader, { key: 0 }))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.value), 1))
          ])
        ])
      ])
    ])
  ]))
}
}

})